import { gql } from 'graphql-request';

export const getDashboardQuery = gql`
  query GetDashboardData(
    $assetIds: [String!]
    $tz: String!
    $filters: [Filter!]! = []
  ) {
    dashboard(assetIds: $assetIds, tz: $tz, filters: $filters) {
      failedTestsChart {
        date
        value
      }
      modelFailuresChart {
        date
        value
      }
      modelsHealth {
        name
        value
      }
      monitoredTablesChart {
        date
        value
      }
      tablesWithTestFailuresChart {
        date
        value
      }
      uniqueTestExecChart {
        date
        value
      }
      warningTestsChart {
        date
        value
      }
    }
  }
`;

export const getDashboardStatsQuery = gql`
  query GetDashboardStatsData($assetIds: [String!], $filters: [Filter!]! = []) {
    dashboardStats(assetIds: $assetIds, filters: $filters) {
      resultsBreakdown {
        name
        value
      }
      tablesHealth {
        name
        value
      }
      monitoredTables {
        name
        value
      }
      summary {
        anomalies {
          failures
          passed
          title
          warnings
          errors
        }
        dbtTests {
          failures
          passed
          title
          warnings
          errors
        }
        freshness {
          failures
          passed
          title
          warnings
          errors
        }
        schemaChanges {
          failures
          passed
          title
          warnings
          errors
        }
        volume {
          failures
          passed
          title
          warnings
          errors
        }
      }
    }
  }
`;
